import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddShiftModal from "../../../components/modelpopup/ShiftModelPopup";
import SearchBox from "../../../components/SearchBox";


const Shift = () => {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingShift, setEditingShift] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
      cleanup();
    };
  }, [isFullScreen]);

  useEffect(() => {
    const fetchShifts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${apiUrl}/shifts/list`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the Authorization header with the token
          },
        });
        setShifts(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching shifts:", error);
        setLoading(false);
      }
    };

    fetchShifts();
  }, [token]); // Include token in the dependency array to re-run effect when token changes

  const onSubmit = (responseData) => {
    if (editingShift) {
      const updatedShifts = shifts.map((shift) =>
        shift.shift_id === responseData.shift_id ? { ...shift, shift_name: responseData.shift_name,shift_time_from:responseData.shift_time_from,shift_time_to:responseData.shift_time_to } : shift
      );
      setShifts(updatedShifts);
    } else {
      setShifts([...shifts, responseData]);
    }
    setEditingShift(null);
  };

  const deleteShift = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this shift!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}/shifts/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the Authorization header with the token
          },
        });
        setShifts(shifts.filter((shift) => shift.shift_id !== id));
        toast.success("Shift has been deleted.");
      } catch (error) {
        let errorMessage = "Failed to delete shift. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };

  const handleEditClick = (shift) => {
    setEditingShift(shift);
  };

  const handleAddClick = () => {
    setEditingShift(null);
  };

  const columns = [
    {
      title: "Shift Name",
      dataIndex: "shift_name",
      sorter: (a, b) => a.shift_name.localeCompare(b.shift_name),
      width: "40%",
    },
    {
      title: "Shift Time From",
      dataIndex: "shift_time_from",
      width: "20%",
    },
    {
      title: "Shift Time To",
      dataIndex: "shift_time_to",
      width: "20%",
    },
    {
      title: "Action",
      render: (_, record) => (
        <div className="dropdown dropdown-action">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => handleEditClick(record)}
              data-bs-toggle="modal"
              data-bs-target="#add_shift"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteShift(record.shift_id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "20%",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
      <div className="page-header page-top-icons">
      <div className="row align-items-center">
            <div className="col-md-4">
              <h3 className="page-title">Shifts</h3>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex title-head">
                <div className="view-icons">
                  <Link to="#" className="grid-view btn btn-link">
                    <i className="las la-redo-alt" />
                  </Link>
                  <Link
                    to="#"
                    className="list-view btn btn-link"
                    id="collapse-header"
                    ref={maximizeBtnRef}
                  >
                    <i className="las la-expand-arrows-alt" />
                  </Link>
                </div>
                <Link
                  to="#"
                  className="btn add-btn custom-btn"
                  onClick={handleAddClick}
                  data-bs-toggle="modal"
                  data-bs-target="#add_shift"
                >
                  <i className="la la-plus-circle custom-icon" /> Add New
                </Link>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
            <SearchBox /> {/* Include SearchBox component here */}
              <Table
                columns={columns}
                dataSource={shifts}
                loading={loading}
                rowKey={(record) => record.shift_id}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Pass editingShift as shiftData prop */}
      <AddShiftModal onSubmit={onSubmit} shiftData={editingShift} />
    </div>
  );
};

export default Shift;
